import { render, staticRenderFns } from "./addpocketmoney.vue?vue&type=template&id=140ad21a&"
import script from "./addpocketmoney.vue?vue&type=script&lang=js&"
export * from "./addpocketmoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports